import chartUtils from '../../../utils/chart-utils';

var buildSankeyTooltip = function buildSankeyTooltip(seriesConfig, data) {
    var defaultTipText = '<span class="tip-header">' + seriesConfig.ValueFieldName + '</span>' + ': <span class="tip-value">' + chartUtils.format(data.options.weight, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

    return defaultTipText;
};

export default buildSankeyTooltip;